import { Flex, Image, Typography, useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";

import {
  isExternalLink,
  isInternalLink,
  isTemplateUrl,
} from "~/core/utils/action.utils";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import type { FooterV4Props } from "../FooterV4";

export const FooterMenu: FC<FooterV4Props> = ({
  getUrl,
  onCallAction,
  data,
  isControlInactive,
}) => {
  const { Link } = useUiKitComponents();
  const { getDirectusImage } = useDirectus();
  const isOnlyOneMenuItem = data?.menu?.action_items?.length === 1;
  return (
    data?.footer_menu && (
      <Flex
        justify="center"
        flexDirection="column"
        align="center"
        m={{ mt: 40, mx: "auto", mb: 32 }}
        gap={32}
        d={{
          align: "flex-start",
          flexDirection: isOnlyOneMenuItem ? "column" : "row",
          justify: "space-between",
          gap: 20,
          flexWrap: "wrap",
          width: "100%",
          m: { mb: 40 },
        }}
      >
        {data?.footer_menu?.action_items?.map((item) => {
          const isRowPositioned = item?.menu_action_items_id?.variant === "row";
          return (
            <Flex justify="center" flexDirection="column" key={item?.id}>
              <Typography
                as="span"
                color="text-secondary-default"
                m={{ mb: 8 }}
                horizontalAlign="center"
                d={{
                  horizontalAlign: "left",
                  m: { mb: 24 },
                  fontWeight: "desktop.bold",
                  fontSize: "title.desktop.xsmall",
                  lineHeight: "title.desktop.xsmall",
                }}
                fontWeight="mobile.bold"
                fontSize={"title.mobile.xsmall"}
                lineHeight={"title.mobile.xsmall"}
              >
                {item?.menu_action_items_id?.translations?.[0]?.name}
              </Typography>
              <Flex
                maxWidth={400}
                as="ul"
                justify="center"
                flexDirection={isRowPositioned ? "row" : "column"}
                gap={isRowPositioned ? 16 : 8}
                flexWrap={"wrap"}
              >
                {item?.menu_action_items_id?.items?.map((actionItem) => {
                  const controlAction =
                    actionItem?.menu_action_sub_items_id?.action;
                  const action = controlAction?.action?.[0];
                  const isInactive = controlAction
                    ? isControlInactive(controlAction)
                    : true;

                  let href: string | undefined;

                  if (isExternalLink(action?.item)) {
                    if (isTemplateUrl(action?.item)) {
                      href = undefined;
                    } else {
                      href = action.item.href ?? undefined;
                    }
                  }
                  if (isInternalLink(action?.item)) {
                    href = action.item.page
                      ? getUrl(action.item.page)
                      : undefined;
                  }
                  const handlePressLink = (): void => {
                    if (controlAction) {
                      onCallAction(controlAction);
                    }
                  };

                  return (
                    !isInactive && (
                      <Link
                        href={href}
                        onClick={handlePressLink}
                        key={actionItem?.id}
                      >
                        <Flex
                          as="li"
                          align="center"
                          justify="center"
                          d={{ justify: "start" }}
                          gap={
                            actionItem?.menu_action_sub_items_id?.icon?.id &&
                            actionItem?.menu_action_sub_items_id
                              ?.translations?.[0]?.name
                              ? 8
                              : undefined
                          }
                        >
                          {actionItem?.menu_action_sub_items_id?.icon?.id && (
                            <Image
                              value={getDirectusImage(
                                actionItem?.menu_action_sub_items_id?.icon
                                  ?.id ?? "",
                                {
                                  format: "webp",
                                  width: 32,
                                },
                              )}
                            />
                          )}

                          <Typography
                            horizontalAlign="center"
                            color="text-secondary-default"
                            d={{
                              horizontalAlign: isOnlyOneMenuItem
                                ? "center"
                                : "left",
                              fontWeight: "desktop.normal",
                              fontSize: "body.desktop.small",
                              lineHeight: "body.desktop.small",
                            }}
                            as="p"
                            fontSize="body.mobile.small"
                            lineHeight="body.mobile.small"
                            fontWeight="mobile.normal"
                          >
                            {
                              actionItem?.menu_action_sub_items_id
                                ?.translations?.[0]?.name
                            }
                          </Typography>
                        </Flex>
                      </Link>
                    )
                  );
                })}
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    )
  );
};
